import React, { useContext } from 'react'

import { ReactComponent as InstaImg } from '../../../assets/icons/social/instagram.svg'
import { ReactComponent as FaceImg } from '../../../assets/icons/social/facebook.svg'
import { ReactComponent as TwitterImg } from '../../../assets/icons/social/twitter.svg'

import { ThemeContext } from '../../../contexts/theme'

function Social(props) {
  const { whitelabelSocialNetworks } = useContext(ThemeContext)

  function socialNetworkIcon(socialNetworkName) {
    if (socialNetworkName === 'facebook') {
      return <FaceImg />
    }

    if (socialNetworkName === 'twitter') {
      return <TwitterImg />
    }

    if (socialNetworkName === 'instagram') {
      return <InstaImg />
    }
  }

  if (!whitelabelSocialNetworks) {
    return null
  }

  return (
    whitelabelSocialNetworks?.map((socialNetwork, index) => (
      <a key={index} href={socialNetwork.link} target='_blank'>
        {socialNetworkIcon(socialNetwork.kind)}
      </a>
    ))
  )
}

export default Social
